import { SortingCenter } from 'types';

export const isParentSortingCenter = (sortingCenter: SortingCenter) => {
  return !Boolean(sortingCenter.parentSortingCenter);
};

export const isChildSortingCenter = (sortingCenter: SortingCenter) => {
  return Boolean(sortingCenter.parentSortingCenter);
};
